export const ADD_LOCATION = 'ADD_LOCATION';
export const GET_LOCATIONS = 'GET_LOCATIONS';
export const REMOVE_LOCATION = 'REMOVE_LOCATION';
export const UPDATE_LOCATIONS = 'UPDATE_LOCATIONS';
export const MODIFY_LOCATION = 'MODIFY_LOCATION';



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/constants/locations_constants.js